import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

import {LanguageService} from '../../language/language.service';

@Component({
  selector: 'app-rozwiazania-duzej-dostepnosci',
  templateUrl: './rozwiazania-duzej-dostepnosci.component.html',
  styleUrls: ['../pages.scss','./rozwiazania-duzej-dostepnosci.component.scss']
})
export class RozwiazaniaDuzejDostepnosciComponent implements OnInit {

  constructor(
    private meta: Meta,
    private titleService: Title,
    public languageService: LanguageService
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle(this.languageService.getLang('ha title', 'seo'));
    this.meta.updateTag({
      name: 'description',
      content: this.languageService.getLang('ha desc', 'seo')
    });
  }
}
